<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CompaniesView"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="companies"
    :headerTitle="'Companies'|pgettext('CompaniesView')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'companies'|pgettext('filename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <ItpButton
        :icon="$config.company.icons[role]"
        :text="messages.create[role]"
        size="sm"
        variant="light"
        class="mx-2"
        @click="evh_6466705138206980_click($event, {})"
      >
      </ItpButton>
      <PageHelp
        path="/claims/companies.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "companies",
    path: "/companies",
    component: "CompaniesView",
    params: [{
      name: "role",
      prop: "role",
    }
      ,
    ]

  }
)

addRoute(
  {
    name: "ownCompanies",
    path: "/own-companies",
    component: "CompaniesView",
    componentProps: [{
      name: "role",
      value: "own",
    }
      ,
    ]

  }
)

addRoute(
  {
    name: "partners",
    path: "/partners",
    component: "CompaniesView",
    componentProps: [{
      name: "role",
      value: "partner",
    }
      ,
    ]

  }
)

@Component()
export default class CompaniesView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  role!: string;

  @Watch('role')
  onRole(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("role")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_company', { parameters: { role: this.role } })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['messages', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          titles: {
            own: this.$fn.pgettext("Companies", "Own companies"),
            partner: this.$fn.pgettext("Companies", "Partners"),
          }
          ,
          create: {
            own: this.$fn.pgettext("Companies|Command", "New company..."),
            partner: this.$fn.pgettext("Companies|Command", "New partner..."),
          }
          ,
        }
        ,
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "code",
          name: this.$fn.pgettext("Companies", "Code"),
          formatter: {
            name: "routeLink",
            to: "company",
            params: {
              id: "id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "name",
          name: this.$fn.pgettext("Companies", "Name"),
          formatter: {
            name: "routeLink",
            to: "company",
            params: {
              id: "id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "tax_number",
          name: this.$fn.pgettext("Companies", "Tax number"),
        }
          ,
        {
          field: "registration_number",
          name: this.$fn.pgettext("Companies", "Registration number"),
        }
          ,
        {
          field: "is_natural_person",
          name: this.$fn.pgettext("Companies", "Natural person"),
          textAlign: "center",
          formatter: {
            name: "checkbox",
          }
          ,
        }
          ,
        {
          field: "sole_proprietor",
          name: this.$fn.pgettext("Companies", "Sole proprietor"),
          textAlign: "center",
          formatter: {
            name: "checkbox",
          }
          ,
        }
          ,
        {
          field: "is_contractor",
          name: this.$fn.pgettext("Companies", "Contractor"),
          textAlign: "center",
          formatter: {
            name: "checkbox",
          }
          ,
        }
          ,
        {
          field: "external_key",
          name: this.$fn.pgettext("Companies", "External key"),
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.messages.titles[this.role],
        icon: this.$config.company.icons[this.role],
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_6952_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_6952, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_6954_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_6954, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_showModal_6956_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6466705138206980_showModal_6956, alias=undefined
    return {
      name: "CreateCompany",
      props: {
        role: this.role,
      }
      ,
    }
  }

  async evh_6466705138206980_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_6952: actions.CloseModalAction;
    evh_7315092382398562_close_6951: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_6954: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_6953: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_6466705138206980_showModal_6956: actions.ShowModalAction;
    evh_6466705138206980_click_6955: actions.EventHandlerImpl;
    evh_6466705138206980_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_6952 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_6952_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_6951 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_6952,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_6951],
      }
    );
    const act_2248226175642056_setData_6954 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_6954_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_6953 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_6954,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_6953],
      }
    );
    const act_6466705138206980_showModal_6956 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6466705138206980_showModal_6956_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_click_6955 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_showModal_6956,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6466705138206980_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_click_6955],
      }
    );
    return {
      act_7315092382398562_closeModal_6952,
      evh_7315092382398562_close_6951,
      evh_7315092382398562_close,
      act_2248226175642056_setData_6954,
      evh_2248226175642056_selectedRowsChanged_6953,
      evh_2248226175642056_selectedRowsChanged,
      act_6466705138206980_showModal_6956,
      evh_6466705138206980_click_6955,
      evh_6466705138206980_click,
    }
  }
}

Vue.component("CompaniesView", CompaniesView);

</script>